let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("irtvq")).then(() => parcelRequire('6XNbh'));